import { IsNotEmpty } from "class-validator";

export class SiteDto {
  _id?: string;

  @IsNotEmpty()
  site: string = "";
}
